import { render, staticRenderFns } from "./OtherUserGroupList.vue?vue&type=template&id=b56e4e8e&scoped=true&lang=pug"
import script from "./OtherUserGroupList.vue?vue&type=script&lang=ts"
export * from "./OtherUserGroupList.vue?vue&type=script&lang=ts"
import style0 from "./OtherUserGroupList.vue?vue&type=style&index=0&id=b56e4e8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b56e4e8e",
  null
  
)

export default component.exports